export const cappedText = (str, cap, indicator = '...') => {
    if (str.length < cap) {
        return str;
    }
    return str.slice(0, cap - indicator.length) + indicator;
};
//# sourceMappingURL=text.js.map